import script from "./ParticipantEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantEntry.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantEntry.vue?vue&type=style&index=0&id=54832080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54832080"]])

export default __exports__